export default "__VITE_ASSET__D5XJaToS__"